import { configureStore } from "@reduxjs/toolkit";
import { config } from "config";
import { routerMiddleware } from "connected-react-router";
import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";

import createRootReducer from "store/reducers";

import { actionStreamMiddleware } from "./action-stream";
import { history } from "./history";

export const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, actionStreamMiddleware, routerMiddleware(history)];

if (config.env !== "production") {
  middlewares.push(
    createLogger({
      collapsed: true,
    })
  );
}

export const store = configureStore({
  reducer: createRootReducer(history),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middlewares),
});
